import axiosPost from "../axiosPost";

export const SFHotelAdminIns = async (
    params = {},
    credentials
) => {
    const body = {
        service: "SFHotelAdminIns",
        params: {
            SFHotelId: params.SFHotelId,
            tipoDeDocumentoCod: params.tipoDeDocumentoCod,
            usuarioNroDeDocumentoX: params.usuarioNroDeDocumentoX,
            usuarioSexo: params.usuarioSexo,
            usuarioFechaDeNacimiento: params.usuarioFechaDeNacimiento,
            usuarioApellidos: params.usuarioApellidos,
            usuarioNombres: params.usuarioNombres,
            usuarioMail: params.usuarioMail,
            rolCod: params.rolCod,
        },
    };
    const result = await axiosPost(body, credentials);
    return result;
};
